var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTShirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5599 7.52332L27.6266 5.05665C27.5033 4.93332 27.3799 4.93332 27.1333 4.93332H23.4333C22.6933 4.93332 22.1999 5.42665 22.1999 6.16665C22.1999 8.26332 20.5966 9.86665 18.5 9.86665C16.4033 9.86665 14.8 8.26332 14.8 6.16665C14.8 5.42665 14.3066 4.93332 13.5666 4.93332H9.86662C9.61995 4.93332 9.49662 4.93332 9.37328 5.05665L4.43995 7.52332C3.94662 7.76999 3.69995 8.13999 3.69995 8.63332V16.0333C3.69995 16.7733 4.19328 17.2667 4.93328 17.2667H8.63328V30.8333C8.63328 31.5733 9.12662 32.0667 9.86662 32.0667H27.1333C27.8733 32.0667 28.3666 31.5733 28.3666 30.8333V17.2667H32.0666C32.8066 17.2667 33.2999 16.7733 33.2999 16.0333V8.63332C33.2999 8.13999 33.0533 7.76999 32.5599 7.52332Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTShirt);
export default __webpack_public_path__ + "static/media/T-shirt.c2db76dc.svg";
export { ForwardRef as ReactComponent };